<template>
    <div class="t-lk-comp">
        <div class="t-lk-container">

            <div v-animation:bottom.delay class="t-lk-comp__container">
                <div class="t-lk-comp__item">
                    <div class="t-lk-comp__img">
                        <img src="/dist/img/cubic.svg" alt="cubic">
                    </div>
                    <div class="t-lk-comp__content">
                        <h3 class="t-lk-comp__title">{{ $root.staticText.lk.compTitle }}</h3>
                        <div class="t-lk-comp__text">{{ $root.staticText.lk.compText }}</div>
                        <div
                            class="t-lk-comp__btn t-btn _lk _border-gray"
                            @click="modalType_requestOpen({
                                title: $root.staticText.lk.compConsultation,
                                options: optionsRequest,
                                button: $root.staticText.forms.btn
                            })"
                        >
                            {{ $root.staticText.lk.compBtn }}
                        </div>
                    </div>
                </div>
                <div class="t-lk-comp__item">
                    <div class="t-lk-comp__img">
                        <img src="/dist/img/circle.png" alt="circle">
                    </div>
                    <div class="t-lk-comp__content">
                        <h3 class="t-lk-comp__title">{{ $root.staticText.lk.compTitle2 }}</h3>
                        <div class="t-lk-comp__text">{{ $root.staticText.lk.compText2 }}</div>
                        <router-link v-if="linkFaq" :to="linkFaq" class="t-lk-comp__btn t-btn _lk _border-gray">
                            {{ $root.staticText.lk.compBtn2 }}
                        </router-link>
                    </div>
                </div>
            </div>

            <template v-if="competencies.length || isLegalInfoSetted">
                <h2 v-animation:bottom.delay class="t-lk-title t-lk-title-link__title t-lk-container-mobile">
                    {{ $root.staticText.lk.mainCompetenciesTitle }}
                </h2>
                <div class="t-lk-main-competencies__container t-lk-comp__wrap">
                    <lk-competencies-item-legal-cmp
                        v-if="isLegalInfoSetted"
                    />

                    <lk-competencies-item-cmp
                        v-for="(item, index) in competencies"
                        :item="item"
                        :key="'lk-competencies-item-' + index"
                        :options-request="optionsRequest"
                        :currencies="currencies"
                    />
                </div>
            </template>

            <template v-if="availableCompetencies.length || !isLegalInfoSetted">
                <h2 v-animation:bottom.delay class="t-lk-title js-scroll t-lk-container-mobile">
                    {{ $root.staticText.lk.compTitleAvailable }}
                </h2>
                <filter-cmp
                    v-animation:bottom.delay
                    v-if="filter"
                    class="t-lk-promotions-selection__filter _white t-lk-comp__filter"
                    :filter="filter"
                    :name-btn="$root.staticText.lk.compFilterBtn"
                    :white="true"
                >
                </filter-cmp>
                <div class="t-lk-comp-available js-comp">
                    <div
                        v-animation:bottom.delay
                        class="t-lk-comp-available__item"
                        v-if="!isLegalInfoSetted"
                    >
                        <div class="t-lk-comp-available__point"/>
                        <div class="t-lk-comp-available__img">
                            Компетенции вашей организации
                        </div>
                        <div class="t-lk-comp-available__desc">
                            Загрузите партнерский сертификат, чтобы получать лиды по решениям вендора
                        </div>
                        <div class="t-lk-comp-available__row">
                            <div
                                class="t-btn _lk _green"
                                @click="updateOrganisationInfo"
                            >
                                {{ $root.staticText.lk.compAvailableBtn }}
                            </div>
                        </div>
                    </div>
                    <div
                        v-animation:bottom.delay
                        v-for="item in availableCompetencies"
                        class="t-lk-comp-available__item"
                    >
                        <div class="t-lk-comp-available__point"></div>
                        <div class="t-lk-comp-available__img">
                            <img v-if="item.img" :src="item.img" :alt="item.nameVendor">
                        </div>
                        <div class="t-lk-comp-available__desc" v-html="item.description"></div>
                        <a v-if="item.link" :href="item.link" target="_blank" class="t-lk-comp-available__link">
                            {{ $root.staticText.lk.compTerms }}
                        </a>
                        <div class="t-lk-comp-available__row">
                            <div
                                class="t-btn _lk _green"
                                @click="checkValidate(item)"
                            >
                                {{ $root.staticText.lk.compAvailableBtn }}
                            </div>
                            <div
                                v-if="item.isBtnTraining"
                                class="t-btn _lk _border-gray"
                                @click="modalType_trainingOpen({
                                    title: $root.staticText.lk.compTraining + ' ' + item.nameVendor,
                                    vendor: item.nameVendor,
                                    vendorId: item.vendorId,
                                    options: optionsRequest,
                                    button: $root.staticText.forms.btn
                                })"
                            >
                                {{ $root.staticText.lk.compAvailableBtn2 }}
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import competenciesItem from '@components/lk/lk-competencies-item/lk-competencies-item.vue';
    import competenciesItemLegal from '@components/lk/lk-competencies-item/lk-competencies-item-legal.vue';
    import filter from '@components/lk/lk-filter/lk-filter.vue';
    import onScrollAnimate from '@assets/js/scrollAnimate.js';
    import {mapActions, mapGetters, mapMutations, mapState} from "vuex";

    export default {
        name: "lk-promotions",
        data() {
            return {
                // linkFaq: null,
                // optionsRequest: null,
                // competencies: [],
                // filter: null,
                // availableCompetencies: [],
                // currencies: [],
            }
        },
        components: {
            'lk-competencies-item-cmp': competenciesItem,
            'lk-competencies-item-legal-cmp': competenciesItemLegal,
            'filter-cmp': filter,
            // 'pagination-cmp': pagination,
        },
        computed: {
            ...mapGetters('lk', {
                profile: 'profile',
                isLegalInfoSetted: 'competencies/isLegalInfoSetted'
            }),
            ...mapState('lk/competencies', {
                linkFaq: state => state.linkFaq,
                optionsRequest: state => state.optionsRequest,
                competencies: state => state.competencies,
                filter: state => state.filter,
                availableCompetencies: state => state.availableCompetencies,
                currencies: state => state.currencies
            })
        },
        methods: {
            ...mapMutations('lk', ['setProfileItem']),
            ...mapActions('modal', [
                'modalType_requestOpen',
                'modalType_competenciesOpen',
                'modalType_trainingOpen',
                'modalType_missingDataOpen',
                'modalType_myOrganisationCompetenciesOpen'
            ]),
            ...mapActions('lk', {
                lk_getCompetenciesPage: 'competencies/getCompetenciesPage',
            }),
            updateOrganisationInfo () {
                this.modalType_myOrganisationCompetenciesOpen({
                    title: this.$root.staticText.lk.compVendor,
                    button: this.$root.staticText.forms.btn,
                    vendorId: this.profile.id,
                    currencies: this.currencies,
                })
            },
            checkValidate(item) {
                // модалка добавить информацию
                if (this.profile.validate === 1) {
                    this.modalType_competenciesOpen({
                        title: this.$root.staticText.lk.compVendor + ' ' + item.nameVendor,
                        button: this.$root.staticText.forms.btn,
                        vendorId: item.vendorId,
                        currencies: this.currencies,
                    });
                    return;
                // модалка заполнить недостающие данные
                }
                
                if (this.profile.validate === 2) {
                    let url = process.env.NODE_ENV !== 'production' ? 'lk/getForm.json' : 'lk/partner/getForm';
                    Vue.http.get(url)
                        .then(response => response.json())
                        .then(
                            (data) => {
                                if (data.success) {
                                    this.modalType_missingDataOpen({
                                        formInfo: data.form,
                                        button: this.$root.staticText.forms.btn,
                                        overflowNone: true,
                                    });
                                }
                            },
                            () => {}
                        );
                    return;
                // заглушка, что данные на модерации
                }
                
                if (this.profile.validate === 3) {
                    this.modalType_missingDataOpen({
                        moderateText: this.$root.staticText.lk.moderateText,
                        overflowNone: true,
                    });
                    return;
                // запрос проверки profile.validate
                }

                let url = process.env.NODE_ENV !== 'production' ? 'lk/isAuth.json' : 'lk/partner/check';
                Vue.http.get(url)
                    .then(response => response.json())
                    .then(
                        (data) => {
                            this.setProfileItem({
                                name: 'validate',
                                value: data.success ? 1 : 2
                            });
                            this.checkValidate(item);
                        },
                        () => {}
                );
            }
        },
        async beforeRouteUpdate(to, _, next) {
            await this.lk_getCompetenciesPage(to.query);
            this.$root.setDataAnimateFalse('.js-comp ');
            next();
        },
        async mounted () {
            await this.lk_getCompetenciesPage(this.$route.query)
        },
    }
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/templates/pages/lk/competencies/index.vue